import * as types from "./types";
import { REQUEST_STATUSES } from "../../../constants";
import { BrandingService, PublicVisualizationService } from "../../../services";

export const getBranding = (propertyId, userId, isPublic = false) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_BRANDING_REQUEST_STATUS,
      payload: { propertyId, status: REQUEST_STATUSES.LOADING },
    });

    const payload = { propertyId };

    if (userId && !isPublic) {
      const { resp, status, err } = await BrandingService.getBranding(propertyId);
      payload.branding = resp || {};
      payload.status = status;
      payload.err = err;
    } else {
      const { resp, status, err } = await PublicVisualizationService.getPublicBranding(propertyId);
      payload.branding = resp || {};
      payload.status = status;
      payload.err = err;
    }

    dispatch({
      type: types.GET_BRANDING,
      payload,
    });
  };
};
